import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import RtiInterventionForm from 'components/organisms/forms/RtiInterventionForm'

import { crudActionsMap } from 'utils/helpers'

const RtiInterventionCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.rti-interventions')} / ${t('common.' + action)}`} />
      <PageBody>
        <RtiInterventionForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default RtiInterventionCrudPage
